import PropTypes from "prop-types";
import { useContext } from "react";
import AppContext from "../services/context";
import clsx from "clsx";

const Input = ({
  type,
  name,
  label,
  placeholder,
  description,
  formik,
  required,
  onBlur,
  onChange,
  onFocus,
  disabled,
}) => {
  const { themeKey } = useContext(AppContext);
  const isDarkTheme = themeKey === 'dark';
  
  const getValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj),
   value = getValue(formik.values, name),
   error = getValue(formik.errors, name)

  return (
  <div className="relative box-border max-w-[200px] pr-1">
    <label htmlFor={name} className="block mb-1">
      {label || placeholder} {required && <span className="text-red-500">*</span>}
    </label>
    {description && <p className="text-xs mb-1">{description}</p>}
    {type !== "textarea" ? (
      <input
        type={type}
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={(e) => {
          formik?.handleChange(e);
          if (onChange) onChange(e);
        }}
        onBlur={(e) => {
          formik?.handleBlur(e);
          if (onBlur) onBlur(e);
        }}
        onFocus={onFocus}
        required={required}
        value={value}
        disabled={disabled}
        className={clsx(
          "outline-none rounded-md px-4 py-2 mb-0.5 border border-green-600",
          "box-border h-8 w-full placeholder-gray-400",
          isDarkTheme ? "bg-gray-700 text-greenbook-dark-text" : "bg-gray-100 text-greenbook-light-text"
        )}
      />
    ) : (
      <textarea
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={(e) => {
          formik?.handleChange(e);
          if (onChange) onChange(e);
        }}
        onBlur={(e) => {
          formik?.handleBlur(e);
          if (onBlur) onBlur(e);
        }}
        onFocus={onFocus}
        required={required}
        value={value}
        className={clsx(
          "outline-none rounded-md px-4 py-2 mb-0.5 border border-green-600",
          "box-border placeholder-gray-400 resize min-w-[400px] min-h-[100px]",
          isDarkTheme ? "bg-gray-700 text-greenbook-dark-text" : "bg-gray-100 text-greenbook-light-text"
        )}
      >
        {value}
      </textarea>
    )}
    {error && (
      <span className="block text-red-500 text-xs">{error}</span>
    )}
  </div>
);
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  formik: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

Input.defaultProps = {
  type: "text",
  placeholder: "Digite seu texto aqui",
  required: false,
  disabled: false,
};

export default Input;